import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit} from '@angular/core';
import parse from 'css/lib/parse';
import {MesConfigService} from "../config.service";

@Component({
  selector: 'app-stylesheet',
  templateUrl: './stylesheet.component.html',
  styles: [
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StylesheetComponent implements OnInit {
  cssClasses: {selector: string, declarations: string}[] = [];
  notFound: string;
  constructor(private configService: MesConfigService, private changeDetector: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.configService.getCssString().subscribe(cssString => {
      if (cssString) {
        const astObject = parse(cssString, {silent: false});
        console.log(astObject);
        astObject.stylesheet.rules?.forEach(rule => {
          rule.selectors?.forEach(selector => {
            let declarations: string = '';
            rule.declarations.forEach(declaration => {
              declarations += `${declaration.property}: ${declaration.value}; `
            });
            this.cssClasses.push({selector, declarations});
          });
        });
      } else {
        this.notFound = 'CSS file not found';
      }
      this.changeDetector.detectChanges();
    });
  }
}
